import 'antd/dist/antd.css';
import './themes/default/main.scss';
import SubRoot from './route/subRoot';
import { Provider } from 'react-redux';
import React, { useEffect } from 'react';
import { initDB } from 'react-indexed-db';
import SocketProvider from './socketManager';
import { createBrowserHistory } from 'history';
import { persistor, store } from './state/store';
import LanguagesProvider from './languageProvider';
import { DBConfig } from '~/state/indexedDB/DBConfig';
import NotMobile from './view/ui/errorPage/NotMobile';
import { userAgentDetect } from './utils/userResolver';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ModalProvider } from './contextAPI/modalContext';
import { LoadingProvider } from './contextAPI/loadingContext';
import { PersistGate } from 'redux-persist/lib/integration/react';
import ErrorBoundary from './view/ui/errorPage/ErrorBoundaryComponent';
import { CenterContextProvider } from './contextAPI/centerController';
import PaveMaintainance from './view/ui/errorPage/PaveMaintainance';
import CacheBuster from './utils/cacheBuster';

const history = createBrowserHistory();
const browserUserInfo = userAgentDetect();
console.log('browserUserInfo --> ', browserUserInfo)
const Root = () => {
  const isMantainance = false;
  useEffect(() => {
    initDB(DBConfig);
  });

  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          // You can decide how and when you want to force reload
          refreshCacheAndReload();
        }
        return (
          <ErrorBoundary history={history}>
            {isMantainance ? (
              <PaveMaintainance />
            ) : (
              <Provider store={store}>
                {!!browserUserInfo &&
                browserUserInfo.browser &&
                browserUserInfo.platform.type === 'desktop' ? (
                  <NotMobile />
                ) : (
                  <CenterContextProvider>
                    <LanguagesProvider>
                      <PersistGate loading={null} persistor={persistor}>
                        <LoadingProvider>
                          <ModalProvider>
                            <SocketProvider>
                              <SubRoot history={history} />
                            </SocketProvider>
                          </ModalProvider>
                        </LoadingProvider>
                      </PersistGate>
                    </LanguagesProvider>
                  </CenterContextProvider>
                )}
              </Provider>
            )}
          </ErrorBoundary>
        );
      }}
    </CacheBuster>
  );
};

export default Root;
